// extracted by mini-css-extract-plugin
export default {"container":"rG-z","modal":"sG-z","dimensions":"tG-z","brandName":"uG-z","productName":"vG-z","labelValue":"wG-z","recipientEmail":"xG-z","recommendedFit":"yG-z","hiddenField":"zG-z"};